/** Linear release flow. At Beta Site is a flag chip, not a step. */
export const FIRMWARE_WORKFLOW_HAPPY_PATH = [
  "Received",
  "In Test",
  "Approved",
  "Production",
  "Obsolete",
] as const;

export const FIRMWARE_WORKFLOW_SIDE_CHIPS = ["At Beta Site", "Rejected", "Recalled"] as const;

export const FIRMWARE_WORKFLOW_STAGE_FLOW = [
  ...FIRMWARE_WORKFLOW_HAPPY_PATH,
  ...FIRMWARE_WORKFLOW_SIDE_CHIPS,
] as const;

export function firmwareHappyPathState(
  state: (typeof FIRMWARE_WORKFLOW_STAGE_FLOW)[number],
): (typeof FIRMWARE_WORKFLOW_HAPPY_PATH)[number] | null {
  if (state === "At Beta Site") return "In Test";
  if (state === "Rejected" || state === "Recalled") return null;
  return state;
}

export function firmwareAtBetaSiteHoverHint(
  lit: boolean,
  customerNames: readonly string[],
): string | null {
  if (!lit) {
    return null;
  }
  const names = customerNames.map((name) => name.trim()).filter((name) => name !== "");
  if (names.length === 0) {
    return "At beta site.";
  }
  return `At beta site for ${names.join(", ")}.`;
}
